<template>
  <SocialMentionCard
    v-bind="{ ...$props, ...$attrs }"
    class="pointer"
    hide-sentiment
    :icon="socialIcon(mention.type)"
    :list-title="listTitle"
    @click="$emit('click', $event)"
    @mention-removed="removeMention"
    @mention-selected="$emit('mention-selected', $event)"
  >
    <template #header>
      <span class="title bold">
        {{ mention.source.name }}

        <strong> · </strong>
        <SocialMentionCardFollowerCount
          v-if="mention.source_follower_count"
          :follower-count="mention.source_follower_count"
        />
        <span
          v-if="hasParentPost"
          class="text-blue-grey bold"
        >
          <QIcon
            name="img:https://assets.streem.com.au/icons/comments.svg"
            size="10px"
          />
          {{ $t("social_mention_card_tweet.replied") }}
        </span>

        <span class="text-blue-grey subtitle">
          <TimeAgo
            class="text-blue-grey self-start"
            :date="mention.timestamp"
          />
        </span>
      </span>
    </template>

    <template #body>
      <MentionExcerpts
        expandable
        :mention="mention"
        :no-highlighting="noHighlighting"
        social-stream
      />

      <div
        v-if="hasParentPost"
        class="parent-bluesky-post-card q-my-md"
      >
        <SocialMentionCardBlueskyPost
          hide-border-color
          :hide-engagement="options.engagementDisabled"
          :mention="mention.parent_post"
          :options="options"
          :stream="stream"
        />
      </div>
    </template>

    <slot />

    <template
      v-if="attachments.length"
      #attachments
    >
      <SocialMentionCardAttachedMedia
        :assets="photos"
        :mention="mention"
        play-media-in-lightbox
      />
    </template>

    <template #engagement-items>
      <SocialMentionEngagementItem
        icon="likes"
        :model-value="mention.likes_count"
      />

      <SocialMentionEngagementItem
        icon="comments"
        :model-value="mention.reply_count"
      />

      <SocialMentionEngagementItem
        icon="reshare"
        :model-value="mention.repost_count"
      />
    </template>
  </SocialMentionCard>
</template>

<script>
import { propsExcept, SocialMentionCard } from "shared/components/MentionCard";
import MentionExcerpts from "shared/components/MentionExcerpts.vue";
import SocialMentionCardAttachedMedia from "shared/components/SocialMentionCardAttachedMedia.vue";
import SocialMentionCardFollowerCount from "shared/components/SocialMentionCardFollowerCount.vue";
import SocialMentionEngagementItem from "shared/components/SocialMentionEngagementItem.vue";
import { socialIcon } from "shared/helpers/media";
import { lowerCase } from "shared/helpers/string";

export default {
  name: "SocialMentionCardBlueskyPost",
  components: {
    MentionExcerpts,
    SocialMentionCard,
    SocialMentionCardFollowerCount,
    SocialMentionEngagementItem,
    SocialMentionCardAttachedMedia,
  },
  props: {
    ...propsExcept(["listTitle"]),
  },
  emits: ["click", "mention-selected", "mention-removed"],
  computed: {
    listTitle() {
      return this.mention.title;
    },
    hasParentPost() {
      return Boolean(this.mention.parent_post);
    },
    attachments() {
      return this.mention.assets;
    },
    photos() {
      return this.attachments.map((attachment) => ({
        type: attachment.type === "image" ? "photo" : attachment.type,
        thumbnail: attachment.thumbnail,
        url: attachment.url,
      }));
    },
  },
  methods: {
    lowerCase,
    socialIcon,
    removeMention(mention) {
      this.$emit("mention-removed", mention);
    },
  },
};
</script>

<style lang="scss" scoped>
.social-icon {
  &.ion-checkmark-circle {
    color: rgb(73 208 103 / 50%);
  }

  &.ion-close-circle {
    color: rgb(249 88 88 / 50%);
  }

  &.ion-remove-circle {
    color: rgb(50 159 236 / 50%);
  }
}

.social-verified {
  vertical-align: 0;
  margin-left: 3px;
}
</style>
